import { render, staticRenderFns } from "./AvatarCropper.vue?vue&type=template&id=561e0476&scoped=true&"
import script from "./AvatarCropper.vue?vue&type=script&lang=js&"
export * from "./AvatarCropper.vue?vue&type=script&lang=js&"
import style0 from "./AvatarCropper.vue?vue&type=style&index=0&id=561e0476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561e0476",
  null
  
)

export default component.exports